import type React from "react";

const ApolloClubPromo: React.FC = () => (
  <div>Placeholder for Apollo Club Promo Page</div>
);

export default ApolloClubPromo;
